import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
var contentSwitcherThemeNative = {
  color: 'primary',
  active: {
    textColor: 'background',
    backgroundColor: 'primary'
  },
  inactive: {
    textColor: 'text',
    backgroundColor: 'background'
  }
};
var contentSwitcherThemeWeb = {
  color: 'primary',
  borders: {
    radius: 'borders.radius'
  },
  disabled: {
    background: colors.cloudGrey,
    font: colors.fogGrey
  },
  active: {
    borderColor: 'primary'
  },
  inactive: {
    textColor: 'text',
    background: 'background',
    borderColor: 'primary'
  }
};

var contentSwitcherDarkThemeWeb = _extends({}, contentSwitcherThemeWeb, {
  disabled: _extends({}, contentSwitcherThemeWeb.disabled, {
    background: colors.inkGrey,
    font: colors.octoberGrey
  })
});

export { contentSwitcherDarkThemeWeb, contentSwitcherThemeNative, contentSwitcherThemeWeb };